import "@/App.css";
import "@/brand.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { BrandProvider } from "@/components/BrandProvider";
import Layout from "@/components/Layout";
import { ChangePasswordDialog } from "@/components/ChangePasswordDialog";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import InvoiceUpload from "@/pages/InvoiceUpload";
import Orders from "@/pages/Orders";
import Conversations from "@/pages/Conversations";
import Payments from "@/pages/Payments";
import Promotions from "@/pages/Promotions";
import Customers from "@/pages/Customers";
import Settings from "@/pages/Settings";
import ImportCatalog from "@/pages/ImportCatalog";
import Followups from "@/pages/Followups";
import MessengerSettlements from "@/pages/MessengerSettlements";
import Reconciliation from "@/pages/Reconciliation";
import PrintOrder from "@/pages/PrintOrder";
import Channels from "@/pages/Channels";
import ShopifySync from "@/pages/ShopifySync";
import ChatDemo from "@/pages/ChatDemo";
import PaymentPage from "@/pages/PaymentPage";
import ComprobantePrint from "@/pages/ComprobantePrint";
import Invoicing from "@/pages/Invoicing";
import SystemStatus from "@/pages/SystemStatus";

function Protected({ children }) {
  const { user, updateUser } = useAuth();
  if (user === undefined)
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Cargando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return (
    <Layout>
      {children}
      <ChangePasswordDialog
        open={!!user.must_change_password}
        mandatory
        onSuccess={() => updateUser({ must_change_password: false })}
      />
    </Layout>
  );
}

function ProtectedNoLayout({ children }) {
  const { user } = useAuth();
  if (user === undefined)
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Cargando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrandProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/chat-demo" element={<ChatDemo />} />
              <Route path="/pagar/:linkId" element={<PaymentPage />} />
              <Route path="/comprobante/:id" element={<ComprobantePrint />} />
              <Route path="/" element={<Protected><Dashboard /></Protected>} />
              <Route path="/productos" element={<Protected><Products /></Protected>} />
              <Route path="/importar-catalogo" element={<Protected><ImportCatalog /></Protected>} />
              <Route path="/facturas" element={<Protected><InvoiceUpload /></Protected>} />
              <Route path="/pedidos" element={<Protected><Orders /></Protected>} />
              <Route path="/conversaciones" element={<Protected><Conversations /></Protected>} />
              <Route path="/pagos" element={<Protected><Payments /></Protected>} />
              <Route path="/seguimientos" element={<Protected><Followups /></Protected>} />
              <Route path="/rendiciones" element={<Protected><MessengerSettlements /></Protected>} />
              <Route path="/conciliacion" element={<Protected><Reconciliation /></Protected>} />
              <Route path="/facturacion" element={<Protected><Invoicing /></Protected>} />
              <Route path="/promociones" element={<Protected><Promotions /></Protected>} />
              <Route path="/clientes" element={<Protected><Customers /></Protected>} />
              <Route path="/canales" element={<Protected><Channels /></Protected>} />
              <Route path="/shopify" element={<Protected><ShopifySync /></Protected>} />
              <Route path="/estado-sistema" element={<Protected><SystemStatus /></Protected>} />
              <Route path="/configuracion" element={<Protected><Settings /></Protected>} />
              <Route path="/imprimir/pedido/:id" element={<ProtectedNoLayout><PrintOrder /></ProtectedNoLayout>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors duration={4000} />
        </AuthProvider>
      </BrandProvider>
    </div>
  );
}

export default App;

